<template>
  <el-row class="settings-devices">
    <el-row v-if="loading || Ponds.length > 0">
      <el-row class="pond-table__header" type="flex" justify="end">
        <el-col :span="3.5">
          <er-input
            inputType="search"
            :debounce="500"
            size="mini"
            :placeholder="$t('Pond_search_pond')"
            v-model="searchPond"
            suffix-icon="el-icon-search"
          ></er-input>
        </el-col>
      </el-row>
      <el-row>
        <er-server-side-pagination-table
          :data="tableData"
          :total="total"
          :key="$i18n.locale"
          :loading="loading"
          :elTableProps="tableProps"
          :action-column="false"
          :filters="filters"
          :columns="tableColumns"
          :page-size="$constants.table['page-size']"
          :pagination-props="$constants.table['pagination-props']"
          @query-change="onQueryChange"
          type="white-header-table"
        >
          <template v-slot:pond_guards="{ row }">
            <div class="tag-list" v-if="row.data['pond_guards'].length > 0">
              <el-tag
                v-for="pg in row.data['pond_guards']"
                :key="pg._id"
                :disable-transitions="true"
                effect="dark"
                size="mini"
                :closable="!isReadOnly"
                @close="handleRemoveDevice('pond_guard', pg, row.data)"
                >{{ pg.title || pg.code }}</el-tag
              >
              <!-- @close="$emit('removePMTag',index)" -->
            </div>
            <span v-else>
              <el-tag size="mini" effect="dark" type="info">
                {{ $t("Comn_na") }}
              </el-tag>
            </span>
          </template>
          <template v-slot:pond_mothers="{ row }">
            <div class="tag-list" v-if="row.data['pond_mothers'].length > 0">
              <template v-for="pm in row.data['pond_mothers']">
                <el-tag
                  :key="pm._id"
                  :disable-transitions="true"
                  effect="dark"
                  size="mini"
                  :closable="!disablePondDeletion(pm)"
                  @close="handleRemoveDevice('pond_mother', pm, row.data)"
                  :style="getBackGroundColorStyleString(pm, row.data._id)"
                >
                  {{ pm.title || pm.code }}
                </el-tag>
              </template>
            </div>
            <span v-else>
              <el-tag size="mini" effect="dark" type="info">
                {{ $t("Comn_na") }}
              </el-tag>
            </span>
          </template>
          <template v-slot:shrimp_talks="{ row }">
            <div class="tag-list" v-if="row.data['shrimp_talks'].length > 0">
              <el-tag
                v-for="st in row.data['shrimp_talks']"
                :disable-transitions="true"
                :key="st._id"
                effect="dark"
                size="mini"
                :closable="!isReadOnly"
                @close="handleRemoveDevice('shrimp_talk', st, row.data)"
                >{{ st.title || stTitle(st.code) }}</el-tag
              >
            </div>
            <span v-else>
              <el-tag size="mini" effect="dark" type="info">
                {{ $t("Comn_na") }}
              </el-tag>
            </span>
          </template>
          <template v-slot:action="{ row }">
            <div style="display: flex;">
              <er-button
                btnType="add"
                type="text"
                size="mini"
                :disabled="isReadOnly"
                :showLabel="true"
                :showIcon="true"
                @click="handleAddDevice(row.data)"
              ></er-button>
            </div>
          </template>
        </er-server-side-pagination-table>
      </el-row>
      <div :key="component">
        <component
          :is="component"
          :showDialog="dialogVisible"
          :pond_details="selectedPond"
          @close_dialog="closeDialog"
        ></component>
      </div>
    </el-row>
    <er-no-ponds :tabData="tabData" :disabled="isReadOnly" v-else />
  </el-row>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import addDevicesToPond from "./addDevicesToPond";
import ShrimpTalk from "@/model/shrimptalk";
// const = createNamespacedHelpers("pond")
export default {
  mixins: [errorHandlerMixin],
  components: {
    addDevicesToPond
  },
  props: {
    tabData: {
      default: {}
    }
  },
  data: function() {
    return {
      data: [],
      total: 0,
      loading: false,
      // tableColumns: [],
      dialogVisible: false,
      currentFilters: new Map(),
      multiSeletedPonds: [],
      searchStr: "",
      component: "",
      selectedPond: null,
      tableProps: {
        // border: true,
        size: "small",
        stripe: false,
        // height:250,
        defaultSort: {
          prop: "title",
          order: "ascending"
        }
      },
      filters: [
        {
          value: "",
          search_prop: "pond_name" // define search_prop for backend usage.
        }
      ],
      query: {
        location_id: null,
        include: ["title", "pond_mothers", "shrimp_talks", "pond_guards"]
      },
      disabled: true,
      searchPond: ""
    };
  },
  ...mapActions("pond", {
    fetchAllPonds: "fetchAllPonds"
  }),
  async mounted() {
    await this.initComponent();
  },
  computed: {
    ...mapGetters("pond", {
      Ponds: "getPonds",
      getPondsObj: "getPondsObj"
    }),
    ...mapGetters("user", {
      getCurrUserLocation: "getCurrUserLocation",
      isReadOnly: "isReadOnly"
    }),
    ...mapGetters("schedules", {
      getMapPondIdFT: "getMapPondIdFT"
    }),
    stTitle() {
      return code => ShrimpTalk.v1Title(code);
    },
    disablePondDeletion() {
      return pm => {
        return [this.isReadOnly].some(x => x);
      };
    },
    tableData() {
      return this.searchPond !== ""
        ? this.data.filter(x =>
            x.title.toLowerCase().includes(this.searchPond.toLowerCase())
          )
        : this.data;
    },
    getBackGroundColorStyleString() {
      return (pm, pondId) => {
        const color = pm.shrimp_talk_id
          ? (
              this.getIndexOnStsByPondId(pondId)[pm.shrimp_talk_id] || {
                color: "#44a1ff"
              }
            ).color
          : "#44a1ff";
        return `background-color:${color};`;
      };
    },
    getIndexOnStsByPondId() {
      return pondId => {
        const stObj = {};
        (this.getPondsObj[pondId] || { shrimp_talks: [] }).shrimp_talks.forEach(
          st => {
            stObj[st._id] = st;
          }
        );
        return stObj;
      };
    },
    tableColumns() {
      return {
        title: {
          prop: "title",
          label: this.$t("Comn_name"),
          sortable: true,
          sortMethod: this.$commonUtils.naturalSort("title")
        },
        pond_guards: {
          prop: "pond_guards",
          label: this.$t("Comn_pond_guard"),
          minWidth: 150
        },
        pond_mothers: {
          prop: "pond_mothers",
          label: this.$tc("Comn_pond_mother", 2),
          minWidth: 270
        },
        shrimp_talks: {
          prop: "shrimp_talks",
          label: "ShrimpTalk",
          minWidth: 150
        },
        action: {
          prop: "action",
          label: this.$t("Comn_actions"),
          default: true,
          minWidth: 80
        }
      };
    }
  },
  created() {},
  methods: {
    ...mapActions("pond", {
      fetchAllPonds: "fetchAllPonds"
    }),
    ...mapActions("shrimptalk", {
      fetchAShrimpTalk: "fetchAShrimpTalk"
    }),
    async initComponent() {
      this.loading = true;
      await this.fetchAllPonds({
        location_id: this.getCurrUserLocation._id,
        get_all: true
      });
      this.loading = false;
    },
    // ...mapActions("schedules", {
    //   fetchAllFeedTemplates: "fetchAllFeedTemplates"
    // }),
    handleAssignSchedulesToPond: function() {
      // console.log(this.multiSeletedPonds)
    },
    doesPondHasDevices: function(row, index) {
      if (row.pond_mothers.length > 0) {
        return true;
      }
      return false;
    },
    closeDialog(event) {
      this.dialogVisible = false;
      this.component = "";

      if (event !== "close") {
        this.loadPondsList();
      }
    },
    loadPondsList: async function() {
      this.query.location_id =
        this.getCurrUserLocation && this.getCurrUserLocation._id;
      this.query.status = ["ACTIVE", "INACTIVE"];
      this.loading = true;
      try {
        const response1 = await this.fetchAllPonds(this.query);
        this.data = this.Ponds;
        this.total = response1.totalPonds;
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    async onQueryChange(queryInfo) {
      switch (queryInfo.type) {
        case "sort":
          this.sort(queryInfo.sort.prop, queryInfo.sort.order);
          break;
        case "filter":
          this.query = {};
          if (queryInfo.filters[0].value !== "") {
            this.query[queryInfo.filters[0].search_prop] =
              queryInfo.filters[0].value;
          }
          this.query.page = 1;
          this.query.limit = 30;
          break;
        case "size":
        case "page":
          this.pagination(queryInfo.page, queryInfo.pageSize);
          break;
        case "init":
          this.query.page = 1;
          this.query.limit = 30;
          break;
        default:
          throw new Error(
            "Not implemented onquerychange for " + queryInfo.type
          );
      }
      await this.loadPondsList();
    },
    sort(property, orderType) {
      this.currentFilters.set("order_by", property);
      this.query.order_by = property;
      if (orderType === "descending") {
        this.currentFilters.set("order_type", "desc");
        this.query.order_type = "desc";
      } else if (orderType === "ascending") {
        this.currentFilters.set("order_type", "asc");
        this.query.order_type = "asc";
      }
    },
    pagination(page, pageSize) {
      this.currentFilters.set("limit", pageSize);
      this.currentFilters.set("page", page);
      this.query.limit = pageSize;
      this.query.page = page;
    },
    handleAddDevice(pond) {
      try {
        this.isEditable(this.tabData);
        this.component = "addDevicesToPond";
        this.dialogVisible = true;
        this.selectedPond = pond;
      } catch (error) {
        this.errorMessages(error, true);
      }
    },
    async handleRemoveDevice(deviceType, device, pond) {
      let loading;
      try {
        this.canUserDelete(this.tabData);
        loading = this.$loading({ fullscreen: true });
        let confirm_message = this.$t("Comn_delete_confirm_msg", {
          item: device.title || device.code,
          source: pond.title
        });
        if (deviceType === "pond_mother") {
          confirm_message = this.$t("pm_delete_confirm_message", {
            device_title: device.title || device.code
          });
          if (device.shrimp_talk_id) {
            const { pond_mothers } = await this.fetchAShrimpTalk(
              device.shrimp_talk_id
            );
            if (pond_mothers.find(x => x._id === device._id)) {
              const { is_master } = pond_mothers.find(
                x => x._id === device._id
              );
              if (is_master) {
                throw {
                  type: "FAIL_TO_SAVE",
                  errors: [
                    { message: this.$t("selected_feeder_is_main_feeder_pond") }
                  ]
                };
              }
            }
          }
        }
        if (deviceType === "shrimp_talk") {
          confirm_message = this.$t("Comn_delete_confirm_msg", {
            item: ShrimpTalk.v1Title(device.code),
            source: pond.title
          });
        }
        await this.$confirm(confirm_message, this.$t("Comn_delete"), {
          confirmButtonText: this.$t("Comn_confirm"),
          cancelButtonText: this.$t("Comn_cancel"),
          cancelButtonClass: "er-button er-button--default",
          confirmButtonClass: "er-button er-button--confirm",
          type: "warning"
        });
        if (deviceType === "pond_mother") {
          await this.notificationHandler(
            "pondmother/unAssignPondMothers",
            "pond_mothers",
            device
          );
        } else if (deviceType === "shrimp_talk") {
          await this.notificationHandler(
            "shrimptalk/unAssignShrimpTalks",
            "shrimp_talks",
            device
          );
        } else if (deviceType === "pond_guard") {
          await this.notificationHandler(
            "pondguard/unAssignPondGuard",
            "pond_guards",
            device
          );
        }
        await this.loadPondsList();
      } catch (error) {
        console.log(error);
        if (error === "cancel") {
        } else {
          this.errorMessages(error, true);
        }
      } finally {
        if (loading) {
          loading.close();
        }
      }
    },
    getDeleteDeviceMessageKey(deviceType) {
      if (deviceType === "pond_mothers") {
        return "Pond_mother_deleted_success";
      } else if (deviceType === "shrimp_talks") {
        return "Shrimp_talk_deleted_success";
      } else if (deviceType === "pond_guards") {
        return "Pond_guard_deleted_success";
      }
      return null;
    },
    async notificationHandler(store_action_name, deviceType, device) {
      let reqPayload = {};
      reqPayload = device._id;
      try {
        await this.$store.dispatch(store_action_name, reqPayload);
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t(this.getDeleteDeviceMessageKey(deviceType)),
          duration: 5000,
          type: "success"
        });
        this.loadPondsList();
      } catch (err) {
        // this.errorMessages(err, true);
        this.$notify({
          title: this.$t("failed"),
          message: err.message,
          duration: 5000,
          type: "error"
        });
      }
    },
    handleAddPondClick() {
      try {
        this.isEditable(this.tabData);
        this.$router.push("map-view");
      } catch (error) {
        this.errorMessages(error, true);
      }
    }
  }
};
</script>

<style lang="scss">
@mixin align-cell-content {
  text-align: left;
  justify-items: flex-start;
  align-items: flex-start;
}
@mixin cell-font-size {
  @include responsiveProperty(
    font-size,
    $app_font_size_small,
    $app_font_size_1,
    $app_font_size_2
  );
}
.settings-devices {
  .server-side-pagination-table {
    .el-table--small td,
    .el-table--small th {
      padding: 3px 0 !important;
    }

    padding: 0 12px;
    .el-table td .cell,
    .el-table th .cell {
      @include cell-font-size;
      @include align-cell-content;
      // * {
      //   @include align-cell-content;
      // }
    }
  }
  .pond-table__header {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: 12px;
    // background: white;
  }
  .tag-list {
    display: flex;
    max-height: 100px;
    flex-wrap: wrap;
    overflow-y: auto;
  }
  .el-table th .cell {
    font-weight: 500;
  }
  .el-tag--dark {
    height: unset;
    display: inline-flex;
    align-items: center;
    padding: 0px 7px;
    background-color: #f2f0f9 !important;
    border-color: #f2f0f9;
    border-radius: 25px;
    @include cell-font-size;
    color: #0a2463;
    margin-top: 2px;
    margin-right: 2px;
    .el-tag__close.el-icon-close {
      background-color: #0a2463;
      @include icon-size(icon-font, prefix);
      top: 0px;
      //   @include
      // height: 18px;
      // width: 18px;
      // line-height: 21px;
      @include respond-to(medium-screens) {
        height: 19px;
        width: 19px;
        line-height: 19px;
      }
      @include respond-to(wide-screens) {
        height: 21px;
        width: 21px;
        line-height: 21px;
      }
      // &.el-icon-close:before {
      //   content: "\e6d8";
      // }
    }
  }
  .el-pagination__sizes {
    .el-input--mini .el-input__inner {
      height: 22px;
      line-height: 22px;
    }
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: $button-color;
    color: #fff;
  }

  .el-pagination {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>